import { all, fork } from 'redux-saga/effects';
import { sagas } from '@wix/da-shared-react/pkg/redux/shared';
import biLogger from '../sagas/biLogger';
import { contactUsSaga } from './contactUs/saga';
import emailUnsubscribe from '../sagas/emailUnsubscribe';

export default function* rootSaga() {
  yield all([
    // project
    fork(biLogger),
    fork(contactUsSaga),
    fork(emailUnsubscribe),
    // shared
    ...sagas.map(fork),
  ]);
}
